// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__kAXQY","loader":"Loader_loader__ChRMX","spin":"Loader_spin__Soegw"};